import React, { useContext } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { setOverlayValue } from "store";
import ImageGalleryContext from "context/image-gallery-context";

import ImageGallery from "partials/ImageGallery";
import IconSelector from "partials/IconSelector";

const ImageOverlay = (props) => {
  const imageGalleryContext = useContext(ImageGalleryContext);

  const clickHandler = () => {
    props.setOverlayValue({
      visible: true,
      component: <ImageGallery images={props.images} startAt={props.image} />,
    });
    imageGalleryContext.setOpen(true);
  };

  return (
    <Overlay onClick={clickHandler} className={props.className}>
      {props.children}
      <IconSelector icon='search' negative />
    </Overlay>
  );
};

const mapStateToProps = (state) => {
  return {
    overlayValue: state.overlayValue,
    images: state.imageGallery,
  };
};

const actions = {
  setOverlayValue,
};

export default connect(mapStateToProps, actions)(ImageOverlay);

const Overlay = styled.div`
  cursor: pointer;

  > span {
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    z-index: 3;
    transform: translate(-50%);
    transition: opacity 0.2s ease-in;
  }

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }

    > span {
      opacity: 1;
    }
  }
`;
